<!-- FORMULARIO INICIO -->
<form action="" autocomplete="off" [formGroup]="formStepWelcomeLto">
  <p class="text-form">Por favor llena los siguientes datos:</p>
  <div class="form">
    <!-- NOMBRES -->
    <mat-form-field appearance="fill">
      <mat-label>Nombre completo</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Ingrese su nombre completo"
        formControlName="firstName"
        oninput="this.value = this.value.toUpperCase()"
        (keydown)="isLetter($event)"
        onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
      />
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['firstName'].invalid &&
          formStepWelcomeLto.controls['firstName'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcomeLto.controls['firstName'].errors &&
            formStepWelcomeLto.controls['firstName'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error
        *ngIf="formStepWelcomeLto.controls['firstName'].hasError('maxlength')"
        >Máximo 45 caracteres.
      </mat-error>
      <mat-error
        *ngIf="formStepWelcomeLto.controls['firstName'].hasError('minlength')"
        >Mínimo 2 caracteres.
      </mat-error>
    </mat-form-field>
    <!-- APELLIDO PATERNO -->
    <mat-form-field appearance="fill">
      <mat-label>Apellido paterno</mat-label>
      <input
        matInput
        placeholder="Ingrese su apellido paterno"
        formControlName="lastName"
        oninput="this.value = this.value.toUpperCase()"
        (keydown)="isLetter($event)"
        onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
      />
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['lastName'].invalid &&
          formStepWelcomeLto.controls['lastName'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcomeLto.controls['lastName'].errors &&
            formStepWelcomeLto.controls['lastName'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error
        *ngIf="formStepWelcomeLto.controls['lastName'].hasError('maxlength')"
        >Máximo 45 caracteres.
      </mat-error>
      <mat-error
        *ngIf="formStepWelcomeLto.controls['lastName'].hasError('minlength')"
        >Mínimo 2 caracteres.
      </mat-error>
    </mat-form-field>
    <!-- APELLIDO MATERNO -->
    <mat-form-field appearance="fill">
      <mat-label>Apellido materno</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Ingrese su apellido materno"
        formControlName="secondLastName"
        oninput="this.value = this.value.toUpperCase()"
        (keydown)="isLetter($event)"
        onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
      />
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['secondLastName'].hasError('maxlength')
        "
        >Máximo 45 caracteres.
      </mat-error>
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['secondLastName'].hasError('minlength')
        "
        >Mínimo 2 caracteres.
      </mat-error>
    </mat-form-field>
    <!-- TELEFONO -->
    <mat-form-field appearance="fill">
      <mat-label>Teléfono</mat-label>
      <input
        appNumber
        (keyup)="checkEvent()"
        matInput
        placeholder="Ingrese su número de celular"
        formControlName="mobilePhoneNumber"
      />
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['mobilePhoneNumber'].invalid &&
          formStepWelcomeLto.controls['mobilePhoneNumber'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcomeLto.controls['mobilePhoneNumber'].errors &&
            formStepWelcomeLto.controls['mobilePhoneNumber'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['mobilePhoneNumber'].hasError('pattern')
        "
        >Debe ingresar 10 caracteres.
      </mat-error>
    </mat-form-field>
    <!-- CORREO ELECTRONICO -->
    <mat-form-field appearance="fill">
      <mat-label>Email registrado en Uber</mat-label>
      <input
        (keyup)="checkEvent()"
        matInput
        placeholder="Ingrese su correo electrónico"
        [formControl]="emailCtrl"
        type="email"
      />
      <mat-error *ngIf="emailCtrl.invalid && emailCtrl.touched">
        <span *ngIf="emailCtrl.errors && emailCtrl.errors['required']"
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error *ngIf="emailCtrl.hasError('pattern')"
        >Formato incorrecto.
      </mat-error>
      <mat-error *ngIf="emailCtrl.hasError('emailEnd')" class="textProviders">
        Formato de email incorrecto.
      </mat-error>
    </mat-form-field>
    <!-- CUIDAD TRABAJAS -->
    <mat-form-field appearance="fill">
      <mat-label>¿En que ciudad trabajas?</mat-label>
      <mat-select (selectionChange)="checkEvent()" formControlName="workCityId">
        <mat-option
          *ngFor="let work of workingCities"
          [value]="work.id"
          (onSelectionChange)="validInputAnotherCity($event)"
        >
          {{ work.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['workCityId'].invalid &&
          formStepWelcomeLto.controls['workCityId'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcomeLto.controls['workCityId'].errors &&
            formStepWelcomeLto.controls['workCityId'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>
    <!-- CIUDAD TRABAJAS(OTRA) -->
    <mat-form-field
      appearance="fill"
      *ngIf="
        formStepWelcomeLto.get('workCityId')!.value ===
        'ecfe9a52-509c-4f95-b327-e887b057ead3'
      "
    >
      <mat-label>Otra(especifique)</mat-label>
      <input
        (keydown)="checkEvent()"
        matInput
        placeholder="Ingrese donde trabaja"
        formControlName="anotherJobCity"
      />
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['anotherJobCity'].invalid &&
          formStepWelcomeLto.controls['anotherJobCity'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcomeLto.controls['anotherJobCity'].errors &&
            formStepWelcomeLto.controls['anotherJobCity'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['anotherJobCity'].hasError('maxlength')
        "
        >Máximo 64 caracteres.
      </mat-error>
    </mat-form-field>
    <!-- COMO TE ENTERASTE -->
    <mat-form-field
      appearance="fill"
      matTooltip="¿Cómo te enteraste de nosotros?"
    >
      <mat-label>¿Cómo te enteraste de nosotros?</mat-label>
      <mat-select
        (selectionChange)="checkEvent()"
        formControlName="whereFindOutId"
      >
        <mat-option
          *ngFor="let opcion of waysFindOuts"
          [value]="opcion.id"
          (onSelectionChange)="validInputAnotherWayFindOut($event)"
        >
          {{ opcion.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          formStepWelcomeLto.controls['whereFindOutId'].invalid &&
          formStepWelcomeLto.controls['whereFindOutId'].touched
        "
      >
        <span
          *ngIf="
            formStepWelcomeLto.controls['whereFindOutId'].errors &&
            formStepWelcomeLto.controls['whereFindOutId'].errors['required']
          "
          >Debe completar este campo</span
        >
      </mat-error>
    </mat-form-field>
  </div>

  <!-- AVISO PRIVACIDAD -->
  <div class="margin-check">
    <mat-checkbox
      (change)="checkPrivacyNoticeEvent()"
      formControlName="privacyNoticeAccepted"
      >Acepto el Aviso de Privacidad/ Consulta de Buró.
    </mat-checkbox>
    <button
      mat-icon-button
      aria-label="Example icon button with a vertical three dot icon"
      class="color-button"
      (click)="openNoticeOfPrivacyDialog()"
    >
      <mat-icon>help</mat-icon>
    </button>
    <mat-error
      class="error"
      *ngIf="
        formStepWelcomeLto.controls['privacyNoticeAccepted'].invalid &&
        formStepWelcomeLto.controls['privacyNoticeAccepted'].touched
      "
    >
      <span
        *ngIf="
          formStepWelcomeLto.controls['privacyNoticeAccepted'].errors &&
          formStepWelcomeLto.controls['privacyNoticeAccepted'].errors[
            'required'
          ]
        "
        >Es necesario aceptar terminos</span
      >
    </mat-error>
  </div>

  <!-- SELECCION AUTO -->
  <div class="data-card" *ngIf="!this.vehicleType">
    <div class="card-text">
      <p class="text-form">
        Selecciona que auto te interesa para aplicar al financiamiento (*):
      </p>
      <p class="text-form-2">
        Las imágenes son representativas de las opciones que existan en el
        momento, y está sujeto a disponibilidad.
      </p>
    </div>

    <div class="data-vehicle">
      <mat-card
        *ngFor="let img of vehicleCategoriesCredit; let i = index"
        [ngClass]="{
          'card-selected mat-elevation-z4': img.id === vehicleSelect,
        }"
        (click)="selectVehicle(img.id)"
      >
        <mat-card-content>
          <div class="img-car">
            <img mat-card-image src="{{ img.imageUrl }}" />
          </div>
          <div
            class="text-data-vehicle"
            [ngClass]="{
              'mat-card-select': img.id === vehicleSelect
            }"
          >
            <strong style="font-size: 17px">{{ img.name }}</strong>
            <p>
              <span [ngClass]="{ hidden: !img.maxPassengers }"
                >{{ img.maxPassengers }} pasajeros.</span
              >
            </p>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-button
            class="boton-siguiente"
            *ngIf="vehicleSelect != img.id"
          >
            Seleccionar
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</form>
